/* cSpell:disable */
import { FooterConfig } from '@tenants/types/tenant';
import {
  getSubDomainUrlWithPath,
  RootDomain,
} from 'constants/domains';
import { LOCALE_EXP_COMMERCIAL_PATHS } from 'types/locales';

export function createFooterConfig(rootDomain: RootDomain): FooterConfig {
  const footerConfig: FooterConfig = {
    footerColumns: {
      column1: [
        {
          label: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_SERVICES_LABEL,
          link: '/our-services',
          isAnchor: false,
          target: '_blank',
        },
        {
          label: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_FINDADVISOR_LABEL, // this is marketing intentional advisors = experts
          link: '/experts',
          isAnchor: false,
          target: '_blank',
        },
        {
          label: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_LISTINGS_LABEL,
          link: '/listings',
          isAnchor: false,
          target: '_blank',
        },
        {
          label: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_JOINEXP_LABEL,
          link: 'https://joinapp.expcommercial.com/',
          isAnchor: false,
          target: '_blank',
        },
        {
          label: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_CALENDAR_LABEL,
          link: '/calendar',
          isAnchor: false,
          target: '_blank',
        },
      ],
      column2: [
        {
          label: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_ABOUT_LABEL,
          link: '/about-us',
          target: '_blank',
        },
        {
          label: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_CONTACT_LABEL,
          link: '/contact-us',
          target: '_blank',
        },
        {
          label: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_CAREERS_LABEL,
          link: '/contact-us',
          target: '_blank',
        },
        {
          label: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_EXPWORLDHOLDINGS_LABEL,
          link: 'https://expworldholdings.com',
          target: '_blank',
        },
      ],
      column3: [
        {
          label: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_LEGAL_TERMSOFUSE_LABEL,
          link: getSubDomainUrlWithPath(rootDomain, 'www', '/terms-of-service'),
          target: '_blank',
        },
        {
          label: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_LEGAL_PRIVACYPOLICY_LABEL,
          link: getSubDomainUrlWithPath(rootDomain, 'www', '/privacy-policy'),
          target: '_blank',
        },
        {
          label: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_LEGAL_COOKIEPOLICY_LABEL,
          link: getSubDomainUrlWithPath(rootDomain, 'www', '/cookie-policy'),
          target: '_blank',
        },
        {
          label: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_LEGAL_DMCANOTICE_LABEL,
          link: getSubDomainUrlWithPath(rootDomain, 'www', '/dmca-notice'),
          target: '_blank',
        },
        {
          label: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_LEGAL_PRIVACYRIGHTSREQUEST_LABEL,
          link: 'https://submit-irm.trustarc.com/services/validation/e6d7516d-df9c-4404-bd9f-21a2f0d2a6a4/',
          target: '_blank',
        },
      ],
      bottom: [
        [
          {
            label: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_DISCLOSURES_TEXASBROKERAGESERVICES_LABEL,
            link: 'https://drive.google.com/file/d/1NMjX7L_BEHJWLQjUXnvf2Ivou4s8sTuA/view',
            isAnchor: true,
            target: '_blank',
          },
        ],
        [
          {
            label: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_DISCLOSURES_TEXASCONSUMERPROTECTION_LABEL,
            link: 'https://www.trec.texas.gov/sites/default/files/pdf-forms/CN%201-4-1_1.pdf',
            isAnchor: true,
            target: '_blank',
          },
        ],
        [
          {
            label: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_DISCLOSURES_FAIRHOUSING_LABEL,
          },
          {
            label: ' →',
            link: 'https://dos.ny.gov/system/files/documents/2021/08/fairhousingnotice.pdf',
            target: '_blank',
          },
          {
            label: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_DISCLOSURES_FAIRHOUSING_CLICKHERE,
            link: 'https://dos.ny.gov/fair-housing',
            isAnchor: true,
            target: '_blank',
          },
        ],
        [
          {
            label: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_DISCLOSURES_STANDARDIZEDOPERATINGPROCEDURE_LABEL,
          },
          {
            label: ' →',
            link: 'https://drive.google.com/file/d/1o1iG6CO5hFgawNGJibmd34loBFJeIqqJ/view',
            target: '_blank',
          },
          {
            label: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_DISCLOSURES_STANDARDIZEDOPERATINGPROCEDURE_CLICKHERE,
            link: 'https://drive.google.com/file/d/1o1iG6CO5hFgawNGJibmd34loBFJeIqqJ/view',
            isAnchor: true,
            target: '_blank',
          },
        ],
        [
          {
            label: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_BROKERS_CALIFORNIA,
          },
        ],
        [
          {
            label: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_BROKERS_SOUTHERNCALIFORNIA,
          },
        ],
        [
          {
            label: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_BROKERS_GREATERLOSANGELES,
          },
        ],
        [
          {
            label: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_BROKERS_NORTHERNCALIFORNIA,
          },
        ],
        [
          {
            label: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_RECAPTCHA_PROTECTED,
          },
          {
            label: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_RECAPTCHA_PRIVACYPOLICY,
            link: 'https://policies.google.com/privacy',
            target: '_blank',
            isAnchor: true,
          },
          {
            label: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_RECAPTCHA_AND,
          },
          {
            label: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_RECAPTCHA_TERMSOFSERVICE,
            link: 'https://policies.google.com/terms',
            target: '_blank',
            isAnchor: true,
          },
          {
            label: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_RECAPTCHA_APPLY,
          },
        ],
      ],
      joinUsLink: getSubDomainUrlWithPath(rootDomain, 'www', '/become-an-advisor'),
      footerImageData: {
        src: '',
        alt: '',
      },
    },
    organization: {
      phoneNumber() {
        return '1 844-539-0722';
      },
      email() {
        return 'info@expcommercial.com';
      },
      address() {
        return '2219 Rimland Drive, Suite 301,<br />Bellingham, Washington, 98226';
      },
      twitterUrl: 'https://x.com/exprealty',
      facebookUrl: 'https://www.facebook.com/profile.php?id=100065096766753',
      instagramUrl: 'https://www.instagram.com/exp.commercial/',
      linkedinUrl: 'https://www.linkedin.com/company/exp-commercial/',
      youtubeUrl: 'https://www.youtube.com/channel/UCZ6dRCbKE_EErGssbZhaW0A',
      joinSectionUrl: getSubDomainUrlWithPath(rootDomain, 'www', '/become-an-advisor'),
    },
    showAccessibilityLink: false,
  };

  return footerConfig;
}